// Same production hostname already hardcoded in index.html's static
// og:url/og:image tags — the one place a unit's public site lives when it
// has no active custom domain of its own.
export const PLATFORM_HOSTNAME = 'site.scoutingops.com';

export interface CanonicalOrigin {
  hostname: string;
  basePath: string;
}

// Every generated public URL (canonical tags, OG/JSON-LD identifiers,
// sitemap, robots, llms.txt) must derive from this instead of
// window.location, so a visitor who lands on a noncanonical host (e.g. the
// platform path for a unit that has since activated a custom domain) still
// gets metadata pointing at the real canonical address. A domain only
// counts here once Heroku has actually issued its certificate
// ('active') — 'verified' means DNS ownership checked out but the site
// isn't safely reachable over HTTPS on that host yet, so the platform path
// remains canonical until then.
export function getCanonicalOrigin(unitSlug: string | null, activeDomainHostname: string | null): CanonicalOrigin | null {
  if (activeDomainHostname) {
    return { hostname: activeDomainHostname, basePath: '' };
  }
  if (unitSlug) {
    return { hostname: PLATFORM_HOSTNAME, basePath: `/site/${unitSlug}` };
  }
  return null;
}

export function getPublicUrl(origin: CanonicalOrigin, pathname = ''): string {
  const normalizedPath = pathname ? `/${pathname.replace(/^\/+|\/+$/g, '')}` : '';
  return `https://${origin.hostname}${origin.basePath}${normalizedPath}`;
}
